import { SidebarNavItem, UserAccountNavItem } from "@/types";
export const dashboardConfig = {
  mainNav: [
    // {
    //   title: "帮助文档",
    //   href: "/docs",
    // },
    // {
    //   title: "技术支持",
    //   href: "/support",
    //   disabled: true,
    // },
  ],
  sidebarNav: [
    {
      title: "我的文献",
      href: "/papers",
      icon: "LiteratureIcon",
    },
    {
      title: "文献综述",
      href: "/summarizes",
      activeHrefs: ["/workflow", "/workflow-creator"],
      icon: "SummarizeIcon",
    },
    {
      title: "主题分类",
      href: "/subjects",
      icon: "MicroscopeIcon",
    },
    {
      title: "笔记摘录",
      href: "/notes",
      icon: "BookmarkIcon",
    },
    // {
    //   component: "Divider",
    // },
    // {
    //   title: "学术助手",
    //   href: "/assistants",
    //   icon: "AssistantsIcon",
    // },
  ] as SidebarNavItem[],
  bottomNav: [
    {
      title: "帮助中心",
      href: "https://nfj2hhi1cw.feishu.cn/wiki/LwGdw80uAiaYNXkFGZmcA7BZnpe",
      icon: "HelpCircleIcon",
      size: 16,
      target: "_blank",
    },
    {
      title: "官方小助手",
      icon: "WechatIcon",
      component: "CommunicateWithUs",
    },

    {
      component: "Divider",
    },
  ] as SidebarNavItem[],
  userAccountNav: [
    {
      title: "个人设置",
      href: "/settings",
      icon: "SettingIcon",
    },
    {
      title: "订单记录",
      href: "/balances?tab=order",
      icon: "OrderRecordIcon",
    },
    {
      title: "打卡与邀请",
      href: "/activities",
      icon: "CalendarIcon",
      size: 16,
    },
    {
      title: "前往官网",
      href: "/",
      icon: "HomeIcon",
      target: "_blank",
    },
  ] as UserAccountNavItem[],
};
